/********************
  Created via mfCLI. Doc: https://marketfuel.getoutline.com/doc/mf-grid-cli-tool-mfcli-CQt1bFpg9u
  Grid Documentation: https://marketfuel.getoutline.com/doc/mf-grid-component-x54vV0bdDu
********************/
import MfGridFunctionalCoreConfig from '@components/general/mfgrid/MfGridFunctionalCoreConfig'
import { store } from '@src/redux/storeConfig/store'

export default function gridConfig(configOptions) {
  const gridUrl = `/mf/grid?table=org_permission_groups`
  const dataKey = 'id'
  const idSortOrder = 'desc'
  let title = 'Org Permissions'
  const titleNoSpace = title.replace(/\s+/g, '')
  const uniqueIdentifier = '7283d5321f701b555017c018110730ed0f27b88ae38a8ff51a17a15ce7771b6e'
  let permissions = 'ORG_PERMISSION'
  let buttonsUrl = '/deletenotneeded'
  let showIds = store.getState().admins.current_admin.show_ids
  let sqlFields = configOptions.sqlFields || []

  if (sqlFields.length == 0) {
    sqlFields = sqlFields.length > 0 ? sqlFields.length : ['id', 'name']
  }

  const columns = [
    {
      allowEditing: false,
      allowHeaderFiltering: false,
      caption: 'ID',
      dataField: 'id',
      dataType: 'number',
      defaultSortOrder: idSortOrder,
      filterOperations: ['='],
      // minWidth: 50 // only use with for the necessary columns. In some cases, use minWidth
      visible: showIds,
      width: 60
    },
    {
      caption: 'Permission Name',
      dataField: 'name',
      dataType: 'string',
      filterOperations: ['contains'],
      visible: true
      // width: 150
    },
    {
      caption: 'Code',
      dataField: 'code',
      dataType: 'string',
      filterOperations: ['contains'],
      visible: false
    },
    {
      caption: 'Description',
      dataField: 'description',
      dataType: 'string',
      filterOperations: ['contains'],
      visible: true
      // width: 200
    },
    {
      caption: 'Create',
      dataType: 'boolean',
      width: 100,
      dataField: 'c'
    },
    {
      caption: 'Read',
      dataType: 'boolean',
      width: 100,
      dataField: 'r'
    },
    {
      caption: 'Update',
      dataType: 'boolean',
      width: 100,
      dataField: 'u'
    },
    {
      caption: 'Delete',
      dataType: 'boolean',
      width: 100,
      dataField: 'd'
    }
  ]

  configOptions['title'] = title
  configOptions['columns'] = columns
  configOptions['titleNoSpace'] = titleNoSpace

  'sqlFields' in configOptions ? delete configOptions.sqlFields : null // sqlFields is not needed in the configOptions object
  let coreConfig = MfGridFunctionalCoreConfig(configOptions)

  return {
    buttonsUrl: buttonsUrl.toLowerCase(),
    columns: coreConfig.columns,
    dataKey: dataKey,
    filter: coreConfig.filter,
    gridUrl: gridUrl,
    idSortOrder: idSortOrder,
    permissions: permissions,
    sqlFields: sqlFields,
    storageKey: uniqueIdentifier,
    title: configOptions.title,
    titleLowerCase: coreConfig.titleLowerCase,
    titleNoSpace: titleNoSpace,
    titleUpperCase: coreConfig.titleUpperCase
  }
}
